import $ from 'wee-dom';
import { _win } from 'core/variables';
import Tweezer from 'tweezer.js';

export default class ScrollToAnchor {
    constructor(e, options = {}) {
        this.hash = options.target.substr(1);
        this.$target = $(options.target);
        this.targetPosition = this.$target.offset().top;
        this.currentPosition = $(_win).scrollTop();
        this.smooth = options.smooth === true;
        this.duration = options.duration || 500;
        this.event = e;
    }

    scroll() {
        if (this.smooth) {
            this.event.preventDefault();

            new Tweezer({
                start: this.currentPosition,
                end: this.targetPosition,
                duration: this.duration,
            }).on('tick', (value) => {
                _win.requestAnimationFrame(() => _win.scrollTo(0, value));
            }).on('done', () => {
                _win.location.hash = this.hash;
            }).begin();
        }
    }
}
